"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPopup = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const settings_1 = require("../config/settings");
const i18next_1 = __importDefault(require("i18next"));
const ConfirmPopup_1 = require("./ConfirmPopup");
const checkmark_svg_1 = __importDefault(require("../../assets/svg/checkmark.svg"));
const blocks_1 = require("../blocks");
const ui_1 = require("@pixi/ui");
const link_svg_1 = __importDefault(require("../../assets/svg/link.svg"));
const AssetManager_1 = __importDefault(require("../managers/AssetManager"));
class SettingsPopup extends ConfirmPopup_1.ConfirmPopup {
    constructor(app, gameManager, animate = true) {
        super(app, null, i18next_1.default.t('close'), null, null, animate);
        this.gameManager = gameManager;
        this.menu = new pixi_js_1.Container();
        const openprivacy = () => {
            window.open(settings_1.Settings.privacy, '_blank');
        };
        const openabout = () => {
            window.open(settings_1.Settings.about, '_blank');
        };
        this.options = new ui_1.List({ type: 'vertical', elementsMargin: (0, Global_1.px)(this.overSmallSize ? 10 : 2), horPadding: (0, Global_1.px)(this.overSmallSize ? 5 : 1) });
        const options = this.gameManager.playerManager.options$.value;
        for (let k in options) {
            if (typeof options[k] === 'boolean') {
                const ok = this.makeCheckbox(options[k], i18next_1.default.t(k));
                this.sigs.push(ok.onCheck.connect((checked) => __awaiter(this, void 0, void 0, function* () {
                    yield this.gameManager.playerManager.setOption(k, checked);
                    AssetManager_1.default.tickSound();
                })));
                this.options.addChild(ok);
            }
        }
        this.menu.addChild(this.options);
        this.aboutText = this.makeLinkText(i18next_1.default.t('mainmenu.about'));
        this.sigs.push(this.aboutText.onPress.connect(openabout));
        this.menu.addChild(this.aboutText);
        this.privacyText = this.makeLinkText(i18next_1.default.t('mainmenu.privacy'));
        this.sigs.push(this.privacyText.onPress.connect(openprivacy));
        this.menu.addChild(this.privacyText);
        this.aboutLink = this.makeLinkButton();
        this.sigs.push(this.aboutLink.onPress.connect(openabout));
        this.menu.addChild(this.aboutLink);
        this.privacyLink = this.makeLinkButton();
        this.sigs.push(this.privacyLink.onPress.connect(openprivacy));
        this.menu.addChild(this.privacyLink);
        this.langText = new pixi_js_1.Text(i18next_1.default.t('mainmenu.language'), blocks_1.Block.textStyle(32));
        this.langSelect = new blocks_1.LanguageSelector(this.app);
        this.langSelect.onChange = (item) => __awaiter(this, void 0, void 0, function* () {
            this.gameManager.langChange$.next(item);
        });
        this.langRow = new pixi_js_1.Container();
        this.langRow.addChild(this.langText, this.langSelect);
        this.menu.addChild(this.langRow);
        this.background.addChild(this.menu);
        this.layout();
    }
    makeCheckbox(checked, text) {
        const size = this.overSmallSize ? 28 : 24;
        const cunchecked = new pixi_js_1.Container();
        cunchecked.addChild(this.makeBox({
            width: size,
            height: size,
            border: 3,
            backgroundColor: settings_1.Settings.lightGrayColor
        }));
        const cchecked = new pixi_js_1.Container();
        cchecked.addChild(this.makeBox({
            width: size,
            height: size,
            border: 3,
            backgroundColor: settings_1.Settings.positiveColor
        }));
        const checkmark = pixi_js_1.Sprite.from(checkmark_svg_1.default);
        checkmark.anchor.set(0.5);
        checkmark.position.set((0, Global_1.px)(size / 2), (0, Global_1.px)(size / 2));
        checkmark.scale.set((0, Global_1.px)(this.overSmallSize ? 0.185 : 0.162));
        cchecked.addChild(checkmark);
        return new ui_1.CheckBox({
            text: text,
            checked: checked,
            style: {
                unchecked: cunchecked,
                checked: cchecked,
                text: blocks_1.Block.textStyle(this.overSmallSize ? 32 : 30),
                textOffset: {
                    x: (0, Global_1.px)(5)
                }
            }
        });
    }
    makeLinkText(txt) {
        const container = new ui_1.ButtonContainer();
        const footerstyle = blocks_1.Block.textStyle(26);
        const p = new pixi_js_1.Text(txt, footerstyle);
        const graphics = (new pixi_js_1.Graphics())
            .beginFill(settings_1.Settings.blackColor)
            .drawRect(0, p.height, p.width + (0, Global_1.px)(1), (0, Global_1.px)(1.8));
        container.addChild(p, graphics);
        return container;
    }
    makeLinkButton() {
        const container = this.makeButton(link_svg_1.default, 0.01);
        container.scale.set((0, Global_1.px)(0.14));
        return container;
    }
    get yescolor() {
        return settings_1.Settings.whiteColor;
    }
    get maxheight() {
        return this.isLandscapeBox ? 280 : (this.overSmallSize ? 500 : 350);
    }
    get maxwidth() {
        return this.isLandscapeBox ? 350 : 450;
    }
    get backgroundsettings() {
        const settings = super.backgroundsettings;
        settings.backgroundColor = settings_1.Settings.lightGrayColor;
        settings.width = Math.min(settings.width, this.maxwidth);
        settings.height = Math.min(settings.height, this.maxheight);
        return settings;
    }
    layout() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        const xpad = (0, Global_1.px)(20);
        const ypad = (0, Global_1.px)(this.isLandscapeBox ? 28 : (this.overSmallSize ? 30 : 18));
        const width = Math.min(this.app.screen.width - (0, Global_1.px)(10) - xpad, (0, Global_1.px)(this.maxwidth));
        (_a = this.langRow) === null || _a === void 0 ? void 0 : _a.position.set(0, ypad);
        if ((0, Global_1.isrtl)()) {
            (_b = this.langSelect) === null || _b === void 0 ? void 0 : _b.position.set(0, 0);
            (_c = this.langText) === null || _c === void 0 ? void 0 : _c.position.set(((_d = this.langSelect) === null || _d === void 0 ? void 0 : _d.width) + xpad, (0, Global_1.px)(5));
        }
        else {
            (_e = this.langSelect) === null || _e === void 0 ? void 0 : _e.position.set(((_f = this.langText) === null || _f === void 0 ? void 0 : _f.width) + xpad, 0);
            (_g = this.langText) === null || _g === void 0 ? void 0 : _g.position.set(0, (0, Global_1.px)(5));
        }
        if (this.options) {
            this.options.type = this.isLandscapeBox ? 'horizontal' : 'vertical';
            this.options.position.set(0, ((_h = this.langRow) === null || _h === void 0 ? void 0 : _h.y) + (0, Global_1.px)(32) + ypad);
        }
        (_j = this.aboutText) === null || _j === void 0 ? void 0 : _j.position.set((0, Global_1.px)(32), ((_k = this.options) === null || _k === void 0 ? void 0 : _k.y) + ((_l = this.options) === null || _l === void 0 ? void 0 : _l.height) + (this.overSmallSize ? ypad : ypad / 3));
        (_m = this.aboutLink) === null || _m === void 0 ? void 0 : _m.position.set(0, ((_o = this.aboutText) === null || _o === void 0 ? void 0 : _o.y) + (0, Global_1.px)(12));
        (_p = this.privacyText) === null || _p === void 0 ? void 0 : _p.position.set((0, Global_1.px)(32), ((_q = this.aboutText) === null || _q === void 0 ? void 0 : _q.y) + ((_r = this.aboutText) === null || _r === void 0 ? void 0 : _r.height) + ypad / 4);
        (_s = this.privacyLink) === null || _s === void 0 ? void 0 : _s.position.set(0, ((_t = this.privacyText) === null || _t === void 0 ? void 0 : _t.y) + (0, Global_1.px)(12));
        (_u = this.menu) === null || _u === void 0 ? void 0 : _u.position.set(width / 2 - this.menu.width / 2, 0);
        super.layout();
        if (this.isLandscapeBox) {
            this.background.y += (0, Global_1.px)(10);
        }
    }
}
exports.SettingsPopup = SettingsPopup;
